import { createContext } from 'react';
import { FsAuthContextValue } from '../type';

export const initialValue: FsAuthContextValue = {
  addUserData: () => {},
};

export const AuthContext = createContext(initialValue);
